import { CityLandingPage } from "../components/CityLandingPage";

export function WebsiteErstellenLassenDresden() {
  return (
    <CityLandingPage
      city="Dresden"
      citySlug="dresden"
      variant="website-erstellen-lassen"
    />
  );
}
